import { Component, HostListener, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-iniciar-sesion',
  templateUrl: './iniciar-sesion.component.html',
  styleUrls: ['./iniciar-sesion.component.scss']
})
export class IniciarSesionComponent implements OnInit {
  public mensajeError: string = '';
  public emailControl = new FormControl('', [Validators.required, Validators.email]);
  public passwordControl = new FormControl('', [Validators.required]);
  public mostrarPassword: boolean = false;
  private intentosMaximos: number = 3;
  public bloqMayusActivado: boolean = false;

  constructor(
    private readonly _router: Router,
  ) { }

  public iniciarSesion() {
    let intentosGuardados = Number(localStorage.getItem('intentos')) || 0;
    const email = this.emailControl.value;
    const password = this.passwordControl.value;

    const usuarios = [
      { email: 'axel@asesorcontable.mx', password: 'Password123' },
      { email: 'carlos@asesorcontable.mx', password: 'Test456' }
    ];

    const usuario = usuarios.find(u => u.email === email);

    if (!email) {
      this.emailControl.setErrors({ emailError: true });
      this.mensajeError = 'El correo es obligatorio';
      return;
    }

    if (this.emailControl.invalid) {
      this.emailControl.setErrors({ emailError: true });
      this.mensajeError = 'El formato del correo no es valido';
      return;
    }

    if (!password) {
      this.passwordControl.setErrors({ passwordError: true });
      this.mensajeError = 'La contraseña es obligatoria.';
      return;
    }

    if (password && this.passwordControl.hasError('passwordError')) {
      this.passwordControl.setErrors(null);
      this.mensajeError = '';
    }

    if (email && this.emailControl.hasError('emailError')) {
      this.emailControl.setErrors(null);
      this.mensajeError = '';
    }

    if (intentosGuardados >= this.intentosMaximos) {
      this.mensajeError = 'Ha superado el número de intentos permitidos. Espere 10 segundos.';

      setTimeout(() => {
          localStorage.setItem('intentos', '0');
          this.mensajeError = '';
      }, 50000);

      return;
    }

    if (usuario?.password != password) {
      this.mensajeError = 'El correo o la contraseña son incorrectos.';
      intentosGuardados++;
      localStorage.setItem('intentos', intentosGuardados.toString());
      return;
    }
  }

  public crearCuenta() {
    this._router.navigate([`crear-usuario`]);
  }

  @HostListener('window:keydown', ['$event'])
  @HostListener('window:keyup', ['$event'])
  public detectarBloqMayusGlobal(event: KeyboardEvent): void {
    this.bloqMayusActivado = event.getModifierState('CapsLock');
  }

  ngOnInit(): void {
  }
}
